import React, { useContext, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListUl, faGlobe, faSignOutAlt, faCreditCard, faChartBar } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Tippy from "@tippyjs/react";
import { ChartContext } from "@contexts/ChartContext";

export const TVChartSidebar = () => {
  const { logout } = useContext(ChartContext);
  const navigate = useNavigate();

  const {
    watcherOpen,
    setWatcherOpen,
    language,
    setLanguage,
    translatedTexts,
    phoneSidebarOpen,
  } = useContext(ChartContext);

  useEffect(() => {
    // Any necessary side effects can be handled here
  }, []);

  if (!phoneSidebarOpen) return null;

  return (
    <section className="slider-bar flex  justify-between px-1 py-2 bg-tt-200">
      <ul className="flex flex-col items-center h-full">
        <li className="text-center p-0">
          <div className="w-12 h-12  bg-transparent rounded-md  px-1" >
          <img src="/assets/tablokhani.png"/>
          </div>
        </li>

        <Tippy content={watcherOpen ? translatedTexts?.sidebar?.close_watchlist : translatedTexts?.sidebar?.open_watchlist} placement="left" animation="scale" duration={0}>
          <li className="mt-1 btn-grey-hover p-2 w-full cursor-pointer" onClick={() => setWatcherOpen(!watcherOpen)}>
            <button className="box-icon">
              <FontAwesomeIcon icon={faListUl} />
            </button>
          </li>
        </Tippy>

   
        <div className="mt-auto w-full">
         

        

          <Tippy content={translatedTexts?.sidebar?.logout} placement="left" animation="scale" duration={0}>
            <li className="mt-1 btn-grey-hover p-2 w-full cursor-pointer" onClick={logout}>
              <button className="box-icon">
                <FontAwesomeIcon icon={faSignOutAlt} />
              </button>
            </li>
          </Tippy>
        </div>
      </ul>
    </section>
  );
};

